import React from 'react'
import { Button, Modal } from './base-ui'
import { HeadLineMedium, LabelMedium } from './base-ui/FontsV2'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

interface ModalHandleInvalidPromotionProps {
  isOpen: boolean
  onClose: VoidFunction
  onOk: VoidFunction
}

export const ModalHandleInvalidPromotion = ({ isOpen, onClose, onOk }: ModalHandleInvalidPromotionProps) => {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} zindex="9999" hideCloseButton={false}>
      <ModalContent>
        <HeadLineMedium>{t('modal.modalCheckoutWithoutPromotion.title')}</HeadLineMedium>
        <LabelMedium>{t('modal.modalCheckoutWithoutPromotion.desc')}</LabelMedium>
      </ModalContent>
      <ModalFooter>
        <Button md minWidth="200px" onClick={onOk}>
          {t('modal.modalCheckoutWithoutPromotion.btnBackToCheckout')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

const ModalContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.verticalSpacingL};
  padding-top: ${({ theme }) => theme.spacing.verticalSpacingXL};
`

const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: ${({ theme }) => theme.spacing.verticalSpacing4XL};
`
